import { ResearchJobInputSchema, type ResearchJobOutput } from '@/entities/jobs/research';
import { fetchBrandSnippet, researchBrandDna } from '@/features/brand-research/researchPrompt';
import { predictionActualCost } from '@/shared/pricing';
import type { Runner, RunnerResult } from './types';

export const researchRunner: Runner = async (job, ctx): Promise<RunnerResult<ResearchJobOutput>> => {
  const input = ResearchJobInputSchema.parse(job.input);
  const snippet =
    input.scrapedSnippet ||
    (input.brandUrl ? await fetchBrandSnippet(input.brandUrl, ctx.signal) : '');

  const result = await researchBrandDna(ctx.client, {
    brandName: input.brandName,
    brandUrl: input.brandUrl,
    scrapedSnippet: snippet,
    llmModelId: input.llmModelId,
    signal: ctx.signal,
  });

  if (input.applyToBrand && job.brandId) {
    await ctx.db.brands.update(job.brandId, {
      dna: result.dna,
      updatedAt: Date.now(),
    });
  }

  const actualCostUsd = predictionActualCost({
    modelSlug: input.llmModelId,
    kind: 'llm',
    ...(result.inputTokens !== undefined && { inputTokens: result.inputTokens }),
    ...(result.outputTokens !== undefined && { outputTokens: result.outputTokens }),
    ...(result.predictTimeSec !== undefined && { predictTimeSec: result.predictTimeSec }),
  });

  return {
    output: { dna: result.dna },
    replicateId: result.replicateId,
    usage: {
      ...(result.inputTokens !== undefined && { inputTokens: result.inputTokens }),
      ...(result.outputTokens !== undefined && { outputTokens: result.outputTokens }),
      ...(result.predictTimeSec !== undefined && { predictTimeSec: result.predictTimeSec }),
    },
    actualCostUsd,
  };
};
